<template>
  <div class="hello container">
    <div class="container mt-3">
      <h3>Añadir categoría</h3>
      <div class="row">
        <!-- name -->
        <div class="col-12 col-sm-6 col-md-3">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Título"
              aria-label="Ingrese aquí"
              aria-describedby="basic-addon1"
              maxlength="40"
              v-model="categoria.name"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 col-md-3">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Sub Categorías"
              aria-label="Ingrese aquí"
              aria-describedby="basic-addon1"
              maxlength="40"
              v-model="nombresubcat"
            />
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-3">
          <button class="btn btn-success" @click="limpiarCampos()">
            Limpiar
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <button class="btn btn-success" @click="agregarSubCategoria()">
            Agregar sub categoría
          </button>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <button class="btn btn-success" @click="saveCategoria()">
            Agregar Categoría
          </button>
        </div>
      </div>

      <div class="row">
        <ul>
          <li v-for="benef in subcategorias" v-bind:key="benef">
            {{ benef.name }}
          </li>
        </ul>
      </div>
    </div>

    <div class="container mt-4">
      <h3>Categorías actuales</h3>
      <table class="table table-hover">
        <thead>
          <tr>
            <th v-for="col in columnas" v-bind:key="col" scope="col">
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="cat in categorias" v-bind:key="cat.id">
            <th scope="row">{{ cat.name }}</th>

            <td>
              <button
                type="button"
                class="btn btn-danger"
                @click="deleteCategoria(cat.id)"
              >
                <font-awesome-icon :icon="cestoBasura" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";

import { environment } from "../../environments/environment";

export default {
  components: { FontAwesomeIcon },
  computed: {
    cestoBasura() {
      return faTrash;
    },
  },
  data() {
    return {
      columnas: ["Nombre", "Acción"],
      categorias: [],
      subcategorias: [],
      categoria: {},
      nombresubcat: "",
      subcategoria: {
        name: "",
      },
      token: "",
    };
  },
  methods: {
    limpiarCampos() {
      this.subcategorias = [];
      this.categoria = {};
      this.subcategoria = {};
      this.nombresubcat = "";
    },
    agregarSubCategoria() {
      if (this.subcategoria) {
        this.subcategoria.name = this.nombresubcat;
        this.subcategorias.push(this.subcategoria);
        this.subcategoria = {};
        this.nombresubcat = "";
      }
    },
    saveCategoria() {
      if (this.subcategorias.length > 0) {
        this.categoria.subcategoria = this.subcategorias;
      } else {
        const subcat = { name: this.categoria.name };
        this.subcategorias.push(subcat);
        this.categoria.subcategoria = this.subcategorias;
      }

      axios.post(environment.API_URL + "categoria", this.categoria).then(() => {
        axios.get(environment.API_URL + "categoria").then((response) => {
          this.categorias = response.data;
          this.limpiarCampos();
        });
      });
    },
    seleccionarComercio: async function (event) {
      const idComercio = event.target.value;

      axios
        .get(environment.API_URL + "comercio/" + idComercio)
        .then((response) => {
          this.comercio = response.data;
        });
    },

    deleteCategoria(idCategoria) {
      axios
        .delete(environment.API_URL + "categoria/" + idCategoria, {
          headers: { Authorization: "Token " + this.token },
        })
        .then(() => {
          axios.get(environment.API_URL + "categoria").then((response) => {
            this.categorias = response.data;
          });
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Problemas",
            text:
              "Esta categoría posee beneficios asociados. Eliminar primero sus beneficios!",
          });
        });
    },
    onSelect(pComercio) {
      this.comercio = pComercio;
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");
    axios.get(environment.API_URL + "categoria").then((response) => {
      this.categorias = response.data;
    });
  },
};
</script>

<style scoped>
</style>
